import React, { forwardRef } from 'react';

import styles from './styles/text_input.module.scss';

export const TextInput = forwardRef(({ ...props }, ref) => {
  return <input ref={ref} className={styles.input} {...props} />;
});
